/**
 * The send glyph — one filled dart, in currentColor.
 *
 * Replaces lucide's `Send` everywhere we ask someone to reach out. That icon
 * is two stroked paths: an outlined plane plus a crease line running from
 * (21.85, 2.15) to the middle of the body. At the 14–16px we use it, three
 * things go wrong — the crease ends a stroke-width from the viewBox corner, so
 * half of it is clipped; it crosses the outline, and the two strokes stack into
 * a patch that reads as a second, darker colour; and a 1.75px stroke on a 14px
 * box lands off-pixel, so the diagonals grey out unevenly.
 *
 * Filled geometry sidesteps all three: no overlaps, nothing within 2px of the
 * edge, and no hairline to misalign. The notch at the tail is what still reads
 * as a paper plane once the outline is gone.
 */
export function SendMark({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M20.94 11.09 4.3 3.42a1.1 1.1 0 0 0-1.5 1.33l1.84 5.48c.12.35.42.6.79.65l6.2.85c.2.03.2.31 0 .34l-6.2.85c-.37.05-.67.3-.79.65L2.8 19.05a1.1 1.1 0 0 0 1.5 1.33l16.64-7.67a1.17 1.17 0 0 0 0-2.12z" />
    </svg>
  )
}
